import { render, staticRenderFns } from "./gatewayDetail.vue?vue&type=template&id=70fa6afc&scoped=true&"
import script from "./gatewayDetail.vue?vue&type=script&lang=js&"
export * from "./gatewayDetail.vue?vue&type=script&lang=js&"
import style0 from "./gatewayDetail.vue?vue&type=style&index=0&id=70fa6afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fa6afc",
  null
  
)

export default component.exports